/* Kiomia - i comandi della galleria della scheda prodotto.

   Lo scorrimento col dito e col trackpad lo fa il browser: il nastro e un
   contenitore con overflow-x e scroll-snap (vedi km-galleria.css). Qui ci sono
   solo le cose che il browser non fa da solo: pallini e frecce, trascinamento
   col mouse, frecce della tastiera, pausa dei video fuori campo, e lo
   spostamento comandato che serve a km-variante-foto.js.

   Tre trappole, tutte scoperte provando davvero.

   Il passo. Sul telefono la foto e larga l'81% e c'e uno stacco fra una e
   l'altra: lo spostamento per andare alla prossima non e la larghezza del
   contenitore, va misurato sulle foto vere.

   Il limite. All'ultima foto lo spazio finirebbe prima; quello che manca lo
   aggiunge km-galleria-fix.css. Qui non chiediamo mai piu del massimo.

   Perche lo spostamento e secco e non morbido. Ci ho provato in due modi e
   tutti e due si rompono. Con scroll-behavior:smooth nel CSS, o con scrollTo
   e behavior smooth, l'aggancio obbligatorio annulla lo scorrimento a meta e la
   galleria torna alla prima foto. Animandolo a mano un fotogramma alla volta
   funziona, ma solo se la scheda del browser e in primo piano: quando non lo e,
   il browser non chiama piu i fotogrammi e lo spostamento resta a meta per
   sempre. Uno spostamento secco invece arriva sempre, in qualunque condizione.
   Lo scorrimento col dito resta morbido lo stesso, perche quello lo fa il
   browser e non passa da qui. */
(function () {
  var FRECCIA_SX = '<svg viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M6.5 1 1.5 6l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var FRECCIA_DX = '<svg viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M1.5 1l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function prepara(nastro) {
    if (!nastro || nastro.getAttribute('data-km-gal')) return;
    var slide = nastro.querySelectorAll('.km-pdp__slide');
    if (slide.length < 2) return;
    nastro.setAttribute('data-km-gal', '1');
    nastro.setAttribute('tabindex', '0');
    nastro.setAttribute('role', 'region');
    nastro.setAttribute('aria-label', 'Immagini del prodotto');

    var ctr = document.createElement('div');
    ctr.className = 'km-gal-ctr';

    var sx = document.createElement('button');
    sx.type = 'button'; sx.className = 'km-gal-fre'; sx.innerHTML = FRECCIA_SX;
    sx.setAttribute('aria-label', 'Immagine precedente');

    var dx = document.createElement('button');
    dx.type = 'button'; dx.className = 'km-gal-fre'; dx.innerHTML = FRECCIA_DX;
    dx.setAttribute('aria-label', 'Immagine successiva');

    var punti = document.createElement('div');
    punti.className = 'km-gal-punti';
    var elenco = [];
    for (var i = 0; i < slide.length; i++) {
      var p = document.createElement('button');
      p.type = 'button'; p.className = 'km-gal-punto';
      p.setAttribute('aria-label', 'Vai all\'immagine ' + (i + 1));
      (function (n) { p.addEventListener('click', function () { vaiA(n); }); })(i);
      punti.appendChild(p); elenco.push(p);
    }

    ctr.appendChild(sx); ctr.appendChild(punti); ctr.appendChild(dx);
    var vecchie = nastro.parentNode.querySelector('.km-pdp__thumbs');
    if (vecchie) vecchie.parentNode.insertBefore(ctr, vecchie);
    else nastro.parentNode.insertBefore(ctr, nastro.nextSibling);

    function passo() {
      if (slide.length > 1) {
        var d = slide[1].offsetLeft - slide[0].offsetLeft;
        if (d > 1) return d;
      }
      return nastro.clientWidth || 1;
    }
    function massimo() { return Math.max(0, nastro.scrollWidth - nastro.clientWidth); }
    function indice() {
      if (nastro.scrollLeft >= massimo() - 2) return slide.length - 1;
      return Math.min(slide.length - 1, Math.round(nastro.scrollLeft / passo()));
    }

    function vaiA(n) {
      n = Math.max(0, Math.min(slide.length - 1, n));
      var meta = Math.max(0, Math.min(n * passo(), massimo()));
      nastro.scrollTo({ left: meta, behavior: 'instant' });
      aggiorna();
    }
    nastro.kmVaiA = vaiA;

    /* Un video che continua a suonare fuori campo e la cosa piu fastidiosa che
       ci sia: appena la sua foto esce dallo schermo lo fermiamo. */
    function fermaVideoLontani(n) {
      for (var i = 0; i < slide.length; i++) {
        if (i === n) continue;
        var v = slide[i].querySelector('video');
        if (v && !v.paused) { try { v.pause(); } catch (e) {} }
        var f = slide[i].querySelector('iframe');
        if (f && f.contentWindow) {
          try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (e) {}
        }
      }
    }

    function aggiorna() {
      var n = indice();
      for (var i = 0; i < elenco.length; i++) {
        var acceso = i === n;
        elenco[i].classList.toggle('is-on', acceso);
        elenco[i].setAttribute('aria-current', acceso ? 'true' : 'false');
      }
      sx.disabled = nastro.scrollLeft <= 2;
      dx.disabled = nastro.scrollLeft >= massimo() - 2;
      fermaVideoLontani(n);
    }

    sx.addEventListener('click', function () { vaiA(indice() - 1); });
    dx.addEventListener('click', function () { vaiA(indice() + 1); });
    nastro.addEventListener('scroll', aggiorna, { passive: true });
    window.addEventListener('resize', aggiorna);

    nastro.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); vaiA(indice() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); vaiA(indice() - 1); }
    });

    /* ---- trascinamento col mouse ----
       Sul telefono non serve, ci pensa il browser. E sopra un video nemmeno: li
       il puntatore serve ai comandi di riproduzione. */
    var giu = false, partenzaX = 0, partenzaScroll = 0, mosso = 0;

    nastro.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('video, iframe, model-viewer')) return;
      giu = true; mosso = 0;
      partenzaX = e.clientX; partenzaScroll = nastro.scrollLeft;
      nastro.classList.add('is-trascino');
    });

    nastro.addEventListener('pointermove', function (e) {
      if (!giu) return;
      var d = e.clientX - partenzaX;
      if (Math.abs(d) > 3) {
        mosso = d;
        if (nastro.setPointerCapture && e.pointerId != null) {
          try { nastro.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      nastro.scrollLeft = partenzaScroll - d;
    });

    function rilascia() {
      if (!giu) return;
      giu = false;
      nastro.classList.remove('is-trascino');
      var n = Math.round(nastro.scrollLeft / passo());
      if (Math.abs(mosso) > passo() * 0.12) {
        n = mosso < 0 ? Math.ceil(nastro.scrollLeft / passo()) : Math.floor(nastro.scrollLeft / passo());
      }
      vaiA(n);
    }
    nastro.addEventListener('pointerup', rilascia);
    nastro.addEventListener('pointercancel', rilascia);
    nastro.addEventListener('pointerleave', rilascia);

    nastro.addEventListener('click', function (e) {
      if (Math.abs(mosso) > 4) { e.preventDefault(); e.stopPropagation(); mosso = 0; }
    }, true);

    /* Le miniature restano nel codice anche se nascoste dal CSS: se un giorno
       tornano visibili devono comunque portare alla foto giusta. */
    var mini = nastro.parentNode.querySelectorAll('[data-km-thumb]');
    for (var t = 0; t < mini.length; t++) {
      (function (n) { mini[n].addEventListener('click', function () { vaiA(n); }); })(t);
    }

    aggiorna();
  }

  function avvia() {
    var nastri = document.querySelectorAll('.km-pdp__gal .km-pdp__stage');
    for (var i = 0; i < nastri.length; i++) prepara(nastri[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
  document.addEventListener('shopify:section:load', avvia);
})();
